"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.windowSizes = void 0;
const windowSizes = {
  tabletPortrait: 600,
  tabletLandscape: 960,
  desktop: 1200,
  desktopLarge: 1800
};
exports.windowSizes = windowSizes;